import isObject from "./is-object.js";

const flatObjectConverter = (input) => {
  const result = {};

  for (const key in input) {
    if (isObject(input[key])) {
      const temp = flatObjectConverter(input[key]);

      for (const modifier in temp) {
        result[`${key}-${modifier}`] = temp[modifier];
      }
    } else if (typeof input[key] === "string") {
      result[key] = input[key];
    }
  }

  return result;
};

export default flatObjectConverter;
